import $ from 'jquery';
import app from './app';
// ---------------------------------------------------------
// Custom Functions for Front-End
// ---------------------------------------------------------
require('../../node_modules/jquery-match-height/dist/jquery.matchHeight');
require('../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox');
require('../../node_modules/chart.js/dist/Chart');
require('../../node_modules/chartjs-plugin-annotation/chartjs-plugin-annotation');
require('../../node_modules/hammerjs/hammer');
require('../../node_modules/chartjs-plugin-zoom/dist/chartjs-plugin-zoom');
import 'swiper/css/swiper.css';
import Swiper from 'swiper/js/swiper.js';


$(document).ready(function() {
  // ==============================================================
  // Active Menu
  // ==============================================================
  $('#btnMenu').click(function() {
    $(this).toggleClass('active');
    $(this).parents('.headTop').next().toggleClass('active');
  });
  // ==============================================================
  // header scroll
  // ==============================================================
  // let lastScroll = 0,
  //   srollTop;
  // $(window).bind('scroll', function() {
  //   srollTop = $(this).scrollTop();
  //   lastScroll = lastScroll < 0 ? 0 : lastScroll;
  //   if (!$('#navi').hasClass('active')) {
  //     if (srollTop < lastScroll && $('#header').hasClass('slideUp')) {
  //       $('#header').removeClass('slideUp').addClass('shadow');
  //     } else if (srollTop > lastScroll) {
  //       $('#header').addClass('slideUp').removeClass('shadow');
  //     }
  //     lastScroll = srollTop;
  //   }
  // });

  // change font size
  // $('#fontChange a').click(function() {
  //   $('#fontChange a').removeClass('active');
  //   $(this).addClass('active');
  // });

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toGMTString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  function getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  function checkFont() {
    var fontSize = getCookie('font-size');
    if (fontSize != '' && fontSize != undefined) {
      $('html').css({
        'font-size': fontSize
      });
      $('.jsFontSize a').removeClass('active');
      $('.jsFontSize a').each(function() {
        var $el = $(this);
        if ($el.data('font') == fontSize) {
          $el.addClass('active');
        }
      });
      if (fontSize != '10px') {
        $('body').addClass('zoom');
        setTimeout(function() {
          $.fn.matchHeight._update();
        }, 250);
      } else {
        $('body').removeClass('zoom');
      }
    } else {
      setCookie('font-size', '10px', 30);
      $('html').css({
        'font-size': '10px'
      });
      $('body').removeClass('zoom');
    }
  }

  checkFont();

  $('.jsFontSize a').on('click', function(e) {
    var $el = $(this),
      fontSize = $el.data('font');
    $el.parents('.jsFontSize').find('a').removeClass('active');
    $el.addClass('active');
    setTimeout(function() {
      $.fn.matchHeight._update();
    }, 250);
    $('html').css({
      'font-size': fontSize
    });
    if (fontSize != '10px') {
      $('body').addClass('zoom');
      setTimeout(function() {
        $.fn.matchHeight._update();
      }, 250);
    } else {
      $('body').removeClass('zoom');
    }
    setCookie('font-size', fontSize, 30);
    e.preventDefault();
  });
  // modal
  function openPopup() {
    $.fancybox.close();
    $('.jsCallPopupDetail').on('click', function(e) {
      var _popup = $(this).attr('href'),
        _srcImg = $(this).find('.imgInfo img').attr('src'),
        _htmlTtl = $(this).find('.ttl').html(),
        _content = $(this).find('.txt01').text();
      e.preventDefault();
      $.fancybox.open({
        src: _popup,
        category: 'inline',
        closeExisting: false,
        opts: {
          touch: false,
          beforeShow: function(instance, current) {
            $('html').css({
              overflow: 'hidden'
            });
            $(_popup).find('.cardFacility img').attr('src', _srcImg);
            $(_popup).find('.cardFacility .ttl').append(_htmlTtl);
            $(_popup).find('.cardFacility .txt01').append(_content);
          },
          beforeClose: function(instance, current) {
            $('html').css({
              'overflow-y': 'auto'
            });
            $(_popup).find('.cardFacility .ttl').empty();
            $(_popup).find('.cardFacility .txt01').empty();
          }
        }
      });
    });

    $('.jsPopupDetailClose').on('click', function(e) {
      $.fancybox.close();
    });
  }
  openPopup();

  // $('.supportList li').matchHeight();
  $('.itemList li').matchHeight();

  // anchorLink
  $('.jsAnchor a[href^=\\#]').click(function(e) {
    var anchorLink = $(this).attr('href');
    if (anchorLink != '#') {
      var offTop = $(anchorLink).offset().top - 30;
      $('body, html').stop().animate({
        scrollTop: offTop
      }, 500);
    }
    return false;
  });
  $('.jsAnchor02 a[href^=\\#]').click(function(e) {
    var anchorLink = $(this).attr('href');
    if (anchorLink != '#') {
      var offTop = $(anchorLink).offset().top - $('#header').height();
      $('body, html').stop().animate({
        scrollTop: offTop
      }, 500);
    }
    return false;
  });

  function keyVCarousel() {
    if ($('.jsKeyCarousel').length) {
      var jsKeyCarousel = new Swiper('.jsKeyCarousel', {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoHeight: false,
        effect: 'fade',
        speed: 5000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false
        },
      });
      jsKeyCarousel.on('slideChangeTransitionStart', function(current) {
        $('.jsKeyCarousel').find('.swiper-slide .keyvTopCarouselItem').removeClass('active');
        $('.jsKeyCarousel').find('.swiper-slide-active .keyvTopCarouselItem').addClass('active');
      });
      jsKeyCarousel.on('slideChangeTransitionEnd', function(current) {
        $('.jsKeyCarousel').find('.swiper-slide .keyvTopCarouselItem').removeClass('active');
        $('.jsKeyCarousel').find('.swiper-slide-active .keyvTopCarouselItem').addClass('active');
      });
    }
  }

  function countdown() {
    if ($('.jsCountdown').length) {
      var $el = $('.jsCountdown'),
        countDownDate = new Date($el.data('date')).getTime(),
        $elDays = $el.find('.jsCountdownDays'),
        $elHours = $el.find('.jsCountdownHours'),
        $elMins = $el.find('.jsCountdownMins'),
        $elSecs = $el.find('.jsCountdownSecs'),
        x = setInterval(function() {
          var now = new Date().getTime(),
            distance = countDownDate - now,
            days = Math.floor(distance / (1000 * 60 * 60 * 24)),
            hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
            minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
            seconds = Math.floor((distance % (1000 * 60)) / 1000);
          $elDays.text(('0' + days).slice(-3));
          $elHours.text(('0' + hours).slice(-2));
          $elMins.text(('0' + minutes).slice(-2));
          $elSecs.text(('0' + seconds).slice(-2));
          if (distance < 0) {
            clearInterval(x);
            $elDays.text('00');
            $elHours.text('00');
            $elMins.text('00');
            $elSecs.text('00');
          } else {
            $el.addClass('visible');
          }
        }, 1000);
    }
  }

  function carousel() {
    if ($('.jsCarousel').length) {
      var jsCarousel = new Swiper('.jsCarousel', {
        slidesPerView: 'auto',
        spaceBetween: 40,
        loop: true,
        autoHeight: false,
        centeredSlides: true,
        speed: 1000,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.jsCarousel ~ .jsNext',
          prevEl: '.jsCarousel ~ .jsPrev',
        },
        breakpoints: {
          320: {
            spaceBetween: 10
          },
          992: {
            spaceBetween: 20
          },
          1200: {
            spaceBetween: 40
          }
        }
      });
    }
  }

  function carousel01() {
    if ($('.jsCarousel01 .swiper-slide').length > 3) {
      jsCarousel = new Swiper('.jsCarousel01', {
        slidesPerView: 'auto',
        spaceBetween: 15,
        loop: true,
        speed: 1000,
        centeredSlides: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        breakpoints: {
          640: {
            slidesPerView: 3,
          },
          992: {
            slidesPerView: 4,
            centeredSlides: false,
            spaceBetween: 40
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 60
          }
        }
      });
    } else if ($('.jsCarousel01 .swiper-slide').length > 1 && $('.jsCarousel01 .swiper-slide').length < 4) {
      var jsCarousel = undefined;
      $(window).on('load resize', function() {
        if ($(window).width() < 1025 && jsCarousel == undefined) {
          jsCarousel = new Swiper('.jsCarousel01', {
            slidesPerView: 'auto',
            spaceBetween: 15,
            loop: true,
            speed: 1000,
            centeredSlides: true,
            autoplay: {
              delay: 5000,
              disableOnInteraction: false
            },
            breakpoints: {
              640: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 4,
                centeredSlides: false,
                spaceBetween: 40
              },
            }
          });
        } else if ($(window).width() > 1024 && jsCarousel != undefined) {
          jsCarousel.destroy();
          jsCarousel = undefined;
        }
      });
    }
  }

  function carousel02() {
    if ($('.jsCarousel02').length) {
      var jsCarousel = new Swiper('.jsCarousel02', {
        slidesPerView: 'auto',
        spaceBetween: 15,
        loop: true,
        centeredSlides: true,
        autoHeight: false,
        speed: 1000,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        breakpoints: {
          640: {
            slidesPerView: 3
          },
          992: {
            slidesPerView: 4,
            centeredSlides: true,
            spaceBetween: 40
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 60
          }
        }
      });
    }
  }

  function tab() {
    $('.jsTab').on('click', function(e) {
      var $this = $(this),
        tabId = $this.data('tab');
      if (!$this.hasClass('active')) {
        $('.jsTab, .jsTabContent').removeClass('active');
        $this.addClass('active');
        $(tabId).addClass('active');
      }
      e.preventDefault();
    });
  }
  //
  if ((navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)) {
    $('.jsBgIE').each(function() {
      var $this = $(this),
        url = 'url(' + $this.find('img').attr('src') + ')';
      $this.css({
        'background-size': 'cover',
        'background-repeat': 'no-repeat',
        'background-position': '50% 20%',
        'background-image': url
      });
      $this.children('img').hide();
    });
  }
  //
  keyVCarousel();
  countdown();
  carousel();
  carousel01();
  carousel02();
  tab();

  var lang = $('html')[0].lang;
  var urlArr = ['/en', '/ch_s', '/ch_t', '/kr', '/pr', '/es'];
  if (lang != 'ja') {
    var pathname = window.location.pathname;
    if (jQuery.inArray(pathname, urlArr) !== -1) {
      $("#lang").val(window.location.href);
    }
  }
  $('#readspeaker_button_sp .rsbtn_play').on('click', function() {
    $(this).parents('#navi').removeClass('active');
    $(this).parents('#navi').prev().find('#btnMenu').removeClass('active');
  })
});